module.exports = __webpack_public_path__ + "static/img/how-it-work-parent.2965671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/how-it-work-parent.png
// module id = IsS5
// module chunks = 14